import Styled from './styled'

export default function PrivacyPolicy({ data }) {
  const content = data?.privacyPolicy?.description || ''

  return (
    <Styled>
      <div className="container">
        <div className="policy-content" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </Styled>
  )
}
